function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEheModule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 555 493",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe0000",
    d: "M 111.5,7.5 C 212.834,7.33334 314.167,7.5 415.5,8C 423.368,10.5348 428.535,15.7014 431,23.5C 431.667,168.833 431.667,314.167 431,459.5C 428.833,468.333 423.333,473.833 414.5,476C 313.5,476.667 212.5,476.667 111.5,476C 102.702,473.869 97.2022,468.369 95,459.5C 94.3333,314.833 94.3333,170.167 95,25.5C 96.9417,16.0646 102.442,10.0646 111.5,7.5 Z M 117.5,30.5 C 214.5,30.5 311.5,30.5 408.5,30.5C 408.5,171.5 408.5,312.5 408.5,453.5C 311.5,453.5 214.5,453.5 117.5,453.5C 117.5,312.5 117.5,171.5 117.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe0000",
    d: "M 220.5,53.5 C 239.33,52.8334 258.33,52.5 277.5,52.5C 298.535,52.3684 319.535,52.8684 340.5,54C 365.182,61.0158 379.682,77.1824 384,102.5C 384.667,195.5 384.667,288.5 384,381.5C 379.008,406.16 364.508,422.327 340.5,430C 314.867,431.139 289.2,431.639 263.5,431.5C 237.8,431.639 212.133,431.139 186.5,430C 159.191,422.024 144.357,403.857 142,375.5C 141.833,330.667 141.667,285.833 141.5,241C 141.353,193.476 141.853,145.976 143,98.5C 152.018,65.4122 173.518,50.9122 207.5,55C 213.56,56.8636 219.226,59.5302 224.5,63C 237,76.8333 249.5,90.6667 262,104.5C 265.905,114.36 262.739,120.36 252.5,122.5C 249.972,122.237 247.639,121.404 245.5,120C 234.167,107.333 222.833,94.6667 211.5,82C 193.174,72.7747 178.674,76.9414 168,94.5C 166.592,98.0569 165.592,101.724 165,105.5C 164.333,196.5 164.333,287.5 165,378.5C 167.945,394.112 177.112,403.946 192.5,408C 239.5,408.667 286.5,408.667 333.5,408C 348.186,404.905 357.353,396.072 361,381.5C 362.487,290.153 362.987,198.986 362.5,108C 360.232,91.0698 350.898,80.4031 334.5,76C 304.833,75.6667 275.167,75.3333 245.5,75C 238.798,65.788 230.465,58.6213 220.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe0000",
    d: "M 327.5,85.5 C 347.128,84.9487 353.961,93.9487 348,112.5C 341.006,119.991 332.84,121.491 323.5,117C 316.009,110.006 314.509,101.84 319,92.5C 321.464,89.519 324.297,87.1856 327.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe0000",
    d: "M 186.5,88.5 C 206.128,87.9487 212.961,96.9487 207,115.5C 200.006,122.991 191.84,124.491 182.5,120C 175.009,113.006 173.509,104.84 178,95.5C 180.464,92.519 183.297,90.1856 186.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe0000",
    d: "M 336.5,225.5 C 346.073,225.033 352.239,229.366 355,238.5C 354.131,253.684 346.298,259.184 331.5,255C 319.817,242.912 321.484,233.079 336.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe0000",
    d: "M 183.5,226.5 C 199.278,228.377 204.445,236.71 199,251.5C 191.272,259.844 182.938,260.511 174,253.5C 166.975,240.736 170.142,231.736 183.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe0000",
    d: "M 280.5,360.5 C 300.128,359.949 306.961,368.949 301,387.5C 294.006,394.991 285.84,396.491 276.5,392C 269.009,385.006 267.509,376.84 272,367.5C 274.464,364.519 277.297,362.186 280.5,360.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe0000",
    d: "M 327.5,360.5 C 347.128,359.949 353.961,368.949 348,387.5C 341.006,394.991 332.84,396.491 323.5,392C 316.009,385.006 314.509,376.84 319,367.5C 321.464,364.519 324.297,362.186 327.5,360.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe0000",
    d: "M 186.5,361.5 C 206.128,360.949 212.961,369.949 207,388.5C 200.006,395.991 191.84,397.491 182.5,393C 175.009,386.006 173.509,377.84 178,368.5C 180.464,365.519 183.297,363.186 186.5,361.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe0000",
    d: "M 233.5,361.5 C 253.128,360.949 259.961,369.949 254,388.5C 247.006,395.991 238.84,397.491 229.5,393C 222.009,386.006 220.509,377.84 225,368.5C 227.464,365.519 230.297,363.186 233.5,361.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEheModule);
export default __webpack_public_path__ + "static/media/ehe_module.15926dd6.svg";
export { ForwardRef as ReactComponent };